export default __webpack_public_path__ + "67412fc0042dc3f1ba8b9d0ad4f624ca.png";